class authService {
    constructor($http, $location, $q, logger, httpRequest, $rootScope, operationService, $state) {
        this.$http = $http
        this.$location = $location
        this.logger = logger
        this.httpRequest = httpRequest
        this.$rootScope = $rootScope
        this.operationService = operationService
        this.$state = $state
        this.$q = $q
        // $location.path("/index/login").replace();
    }

    login(user) {
        // Begin:add by wxb for [清除所有本地存在] on 2017-11-27
        localStorage.clear()
        localStorage.eVersion = eVersion
        // END
        return this.httpRequest.request(() => this.$http.post(`${host.etcloud}auth/login/login`, user))
    }

    isloggedIn() {
        const isloggedIn = localStorage.getItem('id_token')
        return Boolean(isloggedIn)
    }

    addTokens(token) {
        localStorage.setItem('id_token', token)
        this.$rootScope.idToken = token
        // localStorage.setItem('isLogin','true');
    }

    getTokens() {
        return localStorage.getItem('id_token')
    }

    // 获取用户信息
    getUserInfo() {
        const userInfo = localStorage.getItem('user_info')
        if (userInfo) return JSON.parse(userInfo)
        return null
    }

    hasRefreshToken() {
        const refToken = localStorage.getItem('id_token')

        if (refToken == null) {
            this.logout()
        }
        return refToken != null
    }

    logout() {
        const that = this
        const reset = function () {
            localStorage.removeItem('id_token')
            localStorage.removeItem('user_info')
            // localStorage.removeItem('user_info');
            // localStorage.removeItem('user_info');
            //localStorage.removeItem('function_tree')
            that.$rootScope.userInfo = null
            // console.log(that.$rootScope.userMessage);
            // 唐玉宁修改->登出时报错
            that.$rootScope.userMessage.userNoticeList = null
            that.$rootScope.userMessage.taskTotalCount = 0
            that.$rootScope.userMessage.userNoticeCount = 0
            that.operationService.destroy()
            window.layer.closeAll()
            sessionStorage.clear()
        }
        this.httpRequest.del_loginOut('', '用户登出成功').then(
            (res) => {
                reset()
                window.sessionStorage.removeItem('noPopNoticeList')
            },
            (err) => {
                reset()
            }
        )
        this.$location.path('/login').replace()
    }

    clear() {
        localStorage.removeItem('id_token')
        localStorage.removeItem('user_info')
        that.$rootScope.userInfo = null
        that.operationService.destroy()
    }
}

authService.$inject = ['$http', '$location', '$q', 'logger', 'httpRequest', '$rootScope', 'operationService', '$state']
export default authService



// WEBPACK FOOTER //
// ./src/common/services/authService.js